// Vendor
import { RouteRecordRaw } from 'vue-router';

// Components
import ErrorNotFound from '@pages/ErrorNotFound.vue';
import HomePage from '@pages/HomePage.vue';
import ProgramsPage from '@pages/ProgramsPage.vue';
import WeaponsPage from '@pages/WeaponsPage.vue';
import ContactPage from '@pages/ContactPage.vue';
import ChangelogPage from '@pages/ChangelogPage.vue';
import CGU from '@pages/terms/CGUPage.vue';
import A11y from '@pages/terms/A11yPage.vue';
import MentionsLegales from '@pages/terms/MentionsLegalesPage.vue';
import SiteMapPage from '@pages/SiteMapPage.vue';
import AdminUserPage from '@pages/admin/AdminUserPage.vue';
import AdminVideoPage from '@pages/admin/AdminVideoPage.vue';
import SessionPage from '@pages/developer/SessionPage.vue';
import ConsolePage from '@pages/developer/ConsolePage.vue';

// Personal lib
import { RouteEnum } from 'src/shared/enum/route.enum';
import { RoleEnum } from '@shared/enum/role.enum';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: `/${RouteEnum.PROGRAMS}`,
  },
  {
    path: `/${RouteEnum.PROGRAMS}`,
    component: ProgramsPage,
    name: RouteEnum.PROGRAMS,
  },
  {
    path: `/${RouteEnum.WEAPONS}`,
    component: WeaponsPage,
    name: RouteEnum.WEAPONS,
  },
  {
    path: `/${RouteEnum.HOME}`,
    component: HomePage,
    name: RouteEnum.HOME,
  },
  {
    path: `/${RouteEnum.CONTACT}`,
    component: ContactPage,
    name: RouteEnum.CONTACT,
  },
  {
    path: `/${RouteEnum.USERS}`,
    component: AdminUserPage,
    name: RouteEnum.USERS,
    meta: {
      requiredPermissions: [
        RoleEnum.ROLE_ADMIN,
        RoleEnum.ROLE_SUPER_ADMIN,
        RoleEnum.ROLE_USER_VALIDATE,
      ],
    },
  },
  {
    path: `/${RouteEnum.VIDEOS}`,
    component: AdminVideoPage,
    name: RouteEnum.VIDEOS,
    meta: {
      requiredPermissions: [
        RoleEnum.ROLE_SUPER_ADMIN,
        RoleEnum.ROLE_VIDEO_VALIDATE,
        RoleEnum.ROLE_VIDEO_ADD,
      ],
    },
  },
  {
    path: `/${RouteEnum.SITE_MAP}`,
    component: SiteMapPage,
    name: RouteEnum.SITE_MAP,
  },
  {
    path: `/${RouteEnum.CGU}`,
    component: CGU,
    name: RouteEnum.CGU,
  },
  {
    path: `/${RouteEnum.CHANGELOG}`,
    component: ChangelogPage,
    name: RouteEnum.CHANGELOG,
    meta: {
      requiredPermissions: [
        RoleEnum.ROLE_SUPER_ADMIN,
        RoleEnum.ROLE_READ
      ]
    },
  },
  {
    path: `/${RouteEnum.MENTIONS_LEGALES}`,
    component: MentionsLegales,
    name: RouteEnum.MENTIONS_LEGALES,
  },
  {
    path: `/${RouteEnum.A11Y}`,
    component: A11y,
    name: RouteEnum.A11Y,
  },
  {
    path: `/${RouteEnum.DEVELOPER_SESSION}`,
    component: SessionPage,
    name: RouteEnum.DEVELOPER_SESSION,
    meta: {
      requiredPermissions: [
        RoleEnum.ROLE_DEV,
        RoleEnum.ROLE_LOCAL
      ],
    },
  },
  {
    path: `/${RouteEnum.DEVELOPER_CONSOLE}`,
    component: ConsolePage,
    name: RouteEnum.DEVELOPER_CONSOLE,
    meta: {
      requiredPermissions: [
        RoleEnum.ROLE_DEV,
        RoleEnum.ROLE_LOCAL
      ],
    },
  },
];

// Always leave this as last one
routes.push(
  // pathMatch is the name of the param, e.g., going to /not/found yields
  // { params: { pathMatch: ['not', 'found'] }}
  // this is thanks to the last *, meaning repeated params and it is necessary if you
  // plan on directly navigating to the not-found route using its name
  { path: '/:pathMatch(.*)*', name: 'not-found', component: ErrorNotFound },
  // if you omit the last `*`, the `/` character in params will be encoded when resolving or pushing
  { path: '/:pathMatch(.*)', name: 'bad-not-found', component: ErrorNotFound },
);

export default routes;
